"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthService = void 0;
const axios_1 = __importDefault(require("axios"));
const typedi_1 = require("typedi");
const utils_1 = require("@common/http/utils");
const translation_1 = require("@translation/services/translation");
const emitter_1 = require("@event/services/emitter");
const type_1 = require("@event/type");
/**
 * Сервис аутентификации
 */
let AuthService = class AuthService {
    /**
     * Конструктор
     */
    constructor() {
        this.translationService = typedi_1.Container.get(translation_1.TranslationService);
        this.eventEmitter = typedi_1.Container.get(emitter_1.EventEmitter);
    }
    /**
     * Аутентифицирует пользователя
     */
    login(mail, password) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield axios_1.default.get(`/${this.translationService.getLanguagePrefix()}/api/v1/auth/login`, {
                    params: {
                        mail,
                        password,
                    },
                });
                this.eventEmitter.emit(type_1.EventType.USER_AUTHENTICATED, response.data.redirect);
                return (0, utils_1.formatResponse)(response);
            }
            catch (err) {
                throw (0, utils_1.formatErrorResponse)(err);
            }
        });
    }
    /**
     * Аутентифицирует пользователя
     */
    signup(mail, password) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield axios_1.default.get(`/${this.translationService.getLanguagePrefix()}/api/v1/auth/signup`, {
                    params: {
                        mail,
                        password,
                    },
                });
                this.eventEmitter.emit(type_1.EventType.USER_AUTHENTICATED, response.data.redirect);
                return (0, utils_1.formatResponse)(response);
            }
            catch (err) {
                throw (0, utils_1.formatErrorResponse)(err);
            }
        });
    }
    /**
     * Аутентифицирует пользователя с соц.сети
     */
    socialLogin(redirect) {
        this.eventEmitter.emit(type_1.EventType.USER_AUTHENTICATED, redirect);
    }
    /**
     * Востанавливает пароль
     */
    recovery(mail) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield axios_1.default.get(`/${this.translationService.getLanguagePrefix()}/api/v1/auth/recovery-password`, {
                    params: { mail },
                });
                return (0, utils_1.formatResponse)(response);
            }
            catch (err) {
                throw (0, utils_1.formatErrorResponse)(err);
            }
        });
    }
    /**
     * Запрашивает восстановление пароля
     */
    reset(password, repeatPassword) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield axios_1.default.get(`/${this.translationService.getLanguagePrefix()}/api/v1/auth/reset-password`, {
                    params: { password, repeatPassword },
                });
                return (0, utils_1.formatResponse)(response);
            }
            catch (err) {
                throw (0, utils_1.formatErrorResponse)(err);
            }
        });
    }
    /**
     * Возвращает ссылку на аутентификацию через google
     */
    getGoogleLink() {
        return this.getSocialLink('google');
    }
    /**
     * Возвращает ссылку на аутентификацию через facebook
     */
    getFacebookLink() {
        return this.getSocialLink('facebook');
    }
    /**
     * Возвращает ссылку на аутентификацию через apple
     */
    getAppleLink() {
        return this.getSocialLink('apple');
    }
    /**
     * Возвращает ссылку аутентификации черещ соц.сеть
     */
    getSocialLink(type) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield axios_1.default.get(`/${this.translationService.getLanguagePrefix()}/api/v1/auth/social`, {
                    params: { type },
                });
                return (0, utils_1.formatResponse)(response);
            }
            catch (err) {
                throw (0, utils_1.formatErrorResponse)(err);
            }
        });
    }
};
AuthService = __decorate([
    (0, typedi_1.Service)(),
    __metadata("design:paramtypes", [])
], AuthService);
exports.AuthService = AuthService;
